module.exports = __webpack_public_path__ + "img/ThoughtBubbleDisplay.83386b36.svg";